"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _ToggleState = _interopRequireDefault(require("../Topbar/utils/ToggleState"));

var _Accordion = _interopRequireDefault(require("../Expander/Accordion"));

var _Expander = _interopRequireDefault(require("../Expander/Expander"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _excluded = ["navList", "NavItem", "className", "location"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SidebarItem = function SidebarItem(_ref) {
  var item = _ref.item,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('uk-nav__item uk-bghcolor--sidebar', className)
  }, item.icon && /*#__PURE__*/_react.default.createElement("em", {
    className: "fa fa-fw fa-" + item.icon
  }), item.svg && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: item.svg
  }), /*#__PURE__*/_react.default.createElement("span", null, item.name));
};

var findIndexActive = function findIndexActive(node, location) {
  return node.findIndex(function (o) {
    return o.submenu && o.submenu.some(function (e) {
      if (e.submenu) {
        var sub = findIndexActive(o.submenu, location);
        return sub >= 0;
      }

      return location.pathname.includes(e.route);
    });
  });
};

var buildNav = function buildNav(node, NavItem, location, isRoot) {
  if (isRoot === void 0) {
    isRoot = false;
  }

  var activeIndex = findIndexActive(node, location);
  var nav = node.map(function (item, i) {
    if (item.submenu) {
      return /*#__PURE__*/_react.default.createElement(_Expander.default, {
        key: i,
        trigger: /*#__PURE__*/_react.default.createElement(NavItem, {
          item: item
        })
      }, buildNav(item.submenu, NavItem, location));
    }

    return /*#__PURE__*/_react.default.createElement(NavItem, {
      key: i,
      item: item
    });
  });
  return /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    iconPosition: 'hide',
    activeIndex: activeIndex
  }, nav);
};
/**
 * The Sidebar component is used as a container for an application navigation.
 * Mostly used paired with the Topbar component which allows the user to collapse/expand the Sidebar
 */


var Sidebar = function Sidebar(_ref2) {
  var navList = _ref2.navList,
      _ref2$NavItem = _ref2.NavItem,
      NavItem = _ref2$NavItem === void 0 ? SidebarItem : _ref2$NavItem,
      className = _ref2.className,
      controlledLocation = _ref2.location,
      attributes = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var sidebarRef = _react.default.useRef(null);

  var _React$useState = _react.default.useState(controlledLocation),
      location = _React$useState[0],
      setLocation = _React$useState[1];

  _react.default.useEffect(function () {
    return setLocation(controlledLocation);
  }, [controlledLocation]);

  var escFunction = _react.default.useCallback(function (event) {
    if (event.keyCode === 27) {
      document.body.classList.remove('uk-aside-toggled');
    }
  }, []);

  _react.default.useEffect(function () {
    document.addEventListener('keydown', escFunction, {
      capture: true
    });
    return function () {
      document.removeEventListener('keydown', escFunction, {
        capture: true
      });
    };
  }, [escFunction]);

  var classes = (0, _clsx.default)('uk-sidebar', className);
  return /*#__PURE__*/_react.default.createElement("aside", _extends({
    className: classes,
    id: "topBarContent"
  }, attributes, {
    ref: sidebarRef
  }), /*#__PURE__*/_react.default.createElement(_ToggleState.default, {
    state: "uk-aside-toggled"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-sidebar__overlay"
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: "uk-nav"
  }, buildNav(navList, NavItem, location, true)))));
};

Sidebar.propTypes = {
  /**
   * Array of navigation's items
   */
  navList: _propTypes.default.arrayOf(_propTypes.default.shape())
};
Sidebar.defaultProps = {
  navList: []
};
var _default = Sidebar;
exports.default = _default;